import { render, staticRenderFns } from "./RequestServiceResult.vue?vue&type=template&id=0068d288&scoped=true"
import script from "./RequestServiceResult.vue?vue&type=script&lang=js"
export * from "./RequestServiceResult.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceResult.vue?vue&type=style&index=0&id=0068d288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0068d288",
  null
  
)

export default component.exports